import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import FiltroPedidosExpedidosFaturados from "@/shared/view-models/Filtros/FiltroPedidosExpedidosFaturados";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import PedidoController from "@/shared/controllers/cliente/pedidoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import EVENTS from "@/shared/events/events"
import AccountLoged from "@/shared/mixins/AccountLoged";


const name = 'ExpedidosFaturados'
export default {
  name,

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    Dashboard
   },

  props: { },
  watch: {
    formSearch() {
      if (this.formSearch.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  mounted () {
    this.EmpresaArray = this.$store.state.EmpresaArray;
    this.RepresentantesArray = this.$store.state.RepresentanteArray;
    this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
    this.populateTipoPedido()
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.PedidosExpedidosFaturadosArray = null
    });
   },

  updated () { },

  data () {
    return {
        pt1: true,
        ClienteAgrupadorAtiva: true,
        CheckComponentesExpandidos: false,
        CheckClienteAgrupador: false,
        OrcamentoProdutoArray: [],
        ProdutoArray: null,
        formSearch: new FiltroPedidosExpedidosFaturados(),
        dataClientes: [],
        EmpresaArray: [],
        RepresentantesArray: [],
        PedidosExpedidosFaturadosArray: [],
        Colunas : [
          //Campo dos dados , nome que aparece na página
          {field: 'dataUltimoFaturamentoFormatada', header: 'Dt. Faturamento', width: '80px', ordena: true, ordenacao: 'dataUltimoFaturamentoFormatada'},
          {field: 'numeroNotaFiscal', header: 'Nota Fiscal', width: '180px', ordena: true},
          {field: 'pedidoParcela', header: 'Pedido', width: '50px', ordena: true},
          {field: 'numeroOrdemDeCompra', header: 'N° OC', width: '100px', ordena: true, alinha:'flex-end'},
          {field: 'quantidadePedidoParcela', header: 'Qtde.', width: '180px', ordena: true , alinha:'flex-end',type:'number'},
          {field: 'quantidadeExpedida', header: 'Qtde. Expedida', width: '180px', ordena: true , alinha:'flex-end',type:'number'},
      ],

      Colunas2 : [],
      
        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS}, //permite buscar por colunas específicas
          'pedido': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroNotaFiscal': {value: null, matchMode: this.filtros.CONTAINS},
          'dataUltimoFaturamentoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroOrdemDeCompra': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeProduzida': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeExpedida': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeFantasia': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
        },
        TipoPedidoArray: []
     }
  },

  mixins:[AccountLoged],

  methods: {
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    buscarProdutoNovo(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoNovoByPesquisaRepresentante(pesquisa, this.$store.state.representanteSelecionadoId, this.formSearch.UnidadeId).requisicao
        .then((res) => {
          this.OrcamentoProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    Buscar(){
        this.getLogExpedidoFaturado()
        this.pt1 = false
        this.GetExpedidosOuFaturadosByFiltro()
    },

    GetExpedidosOuFaturadosByFiltro(){
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId
      this.$isLoading(true)
      PedidoController.GetExpedidosOuFaturadosByFiltro(this.formSearch).requisicao
      .then(res => {
        this.PedidosExpedidosFaturadosArray = res.data.data
        this.$isLoading(false)
      })
    },

    getLogExpedidoFaturado() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
           `Pedido/getLogExpedidoFaturado/`,
      }).then(() => {

      })
    },

    limparFiltro(){
      this.formSearch = new FiltroPedidosExpedidosFaturados();
      this.dataClientes = []
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    FiltroGetClientes (valor) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      ClienteController.getClienteDropDownsByNome(valor, this.formSearch.UnidadeId, this.formSearch.RepresentanteId).requisicao
        .then((Response) => {
          this.dataClientes = Response.data.data;
        })
        .catch(() => {
        })
      }, 1100);
    },

    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.formSearch.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    getCodigo(produtoId){
      ProdutoController.GetCodigoByProdutoId(produtoId).requisicao
        .then((res) => {
          this.formSearch.CodigoProduto = res.data.message

        })
        .catch(() => {
        })
    },

    getEmpresa () {
      EmpresaController.getEmpresasAtivas().requisicao
      .then((Response) => {
        this.EmpresaArray = Response.data.data
      })
      .catch((Error) => {
        console.error(Error)
      })
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },

    populateTipoPedido() {
      this.axios({
        method: "get",
        url: process.env.VUE_APP_WEB_API + "pedido/GetTipoPedidoEnum",
      })
        .then((response) => {
          this.TipoPedidoArray = response.data.data
        })
        .catch(() => {
        });
    },

    detalhesPedido(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `pedido-expedido-faturado-fluxo/${data.id}/detalhes-pedido-expedido-faturado`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

    atualizaEmpresaRepresentante() {
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    popularDropDrowns() {
      this.atualizaEmpresaRepresentante()
    },

    notasFiscaisRota(data) {
      if(data.notaFiscalId != '00000000-0000-0000-0000-000000000000'){  //temporario
        this.$router.push(`/notas-fiscais-detalhes/${data.notaFiscalId}`)
      }
    },

   },

  computed: { },

};